/**
 * Regular expression to match a sentence in French.
 */
// TODO: Improve the regex to match more cases.
export const FR_SNTNC_REGEX = /^[a-zA-ZÀ-ÿ0-9'’.,!? \\-]+$/;

/**
 * Regular expression to match control characters.
 */
export const CONTROL_CHARS_RE =
  // eslint-disable-next-line no-control-regex
  /[\u0000-\u001F\u007F-\u009F\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g;
